import React, { useCallback, useContext, useEffect, useState } from "react";
import { CartesianGrid, Label, Legend, Scatter, ScatterChart, Text, Tooltip, XAxis, YAxis, ZAxis } from "recharts";
import { useCurrentPng } from "recharts-to-png";
import { saveAs } from "file-saver";
import axios from "axios";
import Contexto from "../comun/Contexto";

const ResIntDist =({idSismo})=> {
    /* Contexto */
    const { urlBaseRest } = useContext(Contexto);

    /** Estado */
    const [intensidadDistancia, setIntensidadDistancia] = useState();    

    /* Efectos */
    useEffect(() => {       
        const traerDatos = async (url, callback) => {
            const res = await axios(url);
            callback(res.data)
        }
    
        traerDatos(urlBaseRest+"grafico_intensidad_distancia/"+idSismo, setIntensidadDistancia);
    }, []);    

    const [getPngGID, { ref: refGraficoGID}] = useCurrentPng();

    const descargarGID = useCallback(async () => {
        const png = await getPngGID();
        if (png) {
            saveAs(png, 'intensidad_distancia.png');
        }
    } , [getPngGID]);

    const etiquetaY = ({ kapi, metric, viewBox }) => {
        return (
            <Text
            dx={30}  
            dy={90 + (viewBox.height/2)}
            angle={-90} >
                Intensidad
            </Text>
        );
    };

    return (
        <div className="ResultadosContenedorH">
            <div>
                <ScatterChart
                ref={refGraficoGID}                        
                width={1100} height={400} margin={{ top: 20, right: 20, bottom: 10, left: 10 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis type="number" dataKey="DIST" name="distancia">
                        <Label value="Distancia (km)" offset={0} position="insideBottom" />
                    </XAxis>
                    <YAxis type="number" dataKey="I" name="intensidad" label={etiquetaY}/>
                    
                    <Tooltip cursor={{ strokeDasharray: '30 30' }} />
                    
                    <Legend verticalAlign="top" height={36}/>
                    <Scatter name="Intensidad vs Distancia" data={intensidadDistancia} fill="#8884d8" />      
                </ScatterChart>
            
                <button onClick={descargarGID} className="GraficosBoton">Exportar imagen</button>
            </div>
            <div className="ResultadosRecuadro">
                Este gr&aacute;fico representa la atenuaci&oacute;n que hace referencia a la intensidad evaluada para cada municipio con relaci&oacute;n a la distancia al hipocentro (punto en profundidad donde se origina el sismo).
                Normalmente la intensidad disminuye al aumentar la distancia desde el hipocentro y si la magnitud del sismo es alta, el sismo tender&aacute; a sentirse a una distancia mayor.
                Es muy importante estudiar la atenuaci&oacute;n de la intensidad porque permite predecir cu&aacute;les pueden ser los efectos de un sismo en el territorio.
            </div>
        </div>
    )
}

export default ResIntDist;